import { z } from 'zod';

import type { FilterValue } from '../createColumnBuilder';

export const numberRangeFilterSchema = z.tuple([z.number(), z.number()]);

const dateRangeFilterSchema = z
  .tuple([z.string().nullish(), z.string().nullish()])
  .transform(([start, end]) => (start || end ? { start, end } : undefined));

export function parseDateRangeFilter(value: unknown) {
  const result = dateRangeFilterSchema.safeParse(value);
  return result.success ? result.data : undefined;
}

export function isFilterApplied(value: FilterValue): boolean {
  if (typeof value === 'boolean') {
    return true;
  }
  if (Array.isArray(value)) {
    if (value[0] === null && value[1] === null) {
      return false;
    }
    return value?.length > 0;
  }
  if (typeof value === 'number') {
    return true;
  }
  if (value === null) {
    return false;
  }
  return value?.length > 0;
}
